import {
    GET_INTERNSHIP_STRUCTURES_FAIL,
    GET_INTERNSHIP_STRUCTURES_SUCCESS,
    ADD_INTERNSHIP_STRUCTURE_SUCCESS,
    ADD_INTERNSHIP_STRUCTURE_FAIL,
    UPDATE_INTERNSHIP_STRUCTURE_SUCCESS,
    UPDATE_INTERNSHIP_STRUCTURE_FAIL,
    DELETE_INTERNSHIP_STRUCTURE_SUCCESS,
    DELETE_INTERNSHIP_STRUCTURE_FAIL,
} from "./actionTypes";

const INIT_STATE = {
    internshipStructures: [],
    error: null,
    loading: true,
    lastActionSuccess: false
};

const internshipStructureReducer = (state = INIT_STATE, action) => {
    switch (action.type) {
        // Récupération des structures
        case GET_INTERNSHIP_STRUCTURES_SUCCESS:
            return {
                ...state,
                internshipStructures: action.payload.internshipStructures, // tableau d'objetsstructure
                loading: false,
                error: null
            };

        case GET_INTERNSHIP_STRUCTURES_FAIL:
            return {
                ...state,
                error: action.payload,
                loading: false
            };

        // Ajout d'unestructuree
        case ADD_INTERNSHIP_STRUCTURE_SUCCESS:
            return {
                ...state,
                internshipStructures: [action.payload, ...state.internshipStructures], // ajoute au début du tableau
                error: null,
                lastActionSuccess: true
            };

        case ADD_INTERNSHIP_STRUCTURE_FAIL:
            return {
                ...state,
                error: action.payload,
                lastActionSuccess: false
            };

        // Mise à jour d'unestructuree
        case UPDATE_INTERNSHIP_STRUCTURE_SUCCESS:
            return {
                ...state,
                internshipStructures: state.internshipStructures.map(internshipStructure =>
                   internshipStructure.id.toString() === action.payload.id.toString()
                        ? action.payload // remplace entièrement l'objetstructure
                        :internshipStructure
                ),
                error: null,
                 lastActionSuccess: true
            };

        case UPDATE_INTERNSHIP_STRUCTURE_FAIL:
            return {
                ...state,
                error: action.payload,
                lastActionSuccess: false
            };

        // Suppression d'unestructuree
        case DELETE_INTERNSHIP_STRUCTURE_SUCCESS:
            return {
                ...state,
                internshipStructures: state.internshipStructures.filter(
                   internshipStructure =>internshipStructure.id !== action.payload
                ),
                error: null
            };


        case DELETE_INTERNSHIP_STRUCTURE_FAIL:
            return {
                ...state,
                error: action.payload
            };


        case "RESET_LAST_ACTION_SUCCESS":
            return { 
                ...state, 
                lastActionSuccess: false 
            };


        default:
            return state;
    }
};

export default internshipStructureReducer;
